import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Button, showToast } from '@deeptrue-frontend/ui';
import Link from '@material-ui/core/Link';
import { useFormatMessage } from 'components/IntlProvider';
import { generateSampleCsv } from 'utils/generateSampleCsv';
import api from 'api';

const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
`;

const ButtonStyled = styled(Button)`
  font-size: 1rem;
`;

const SectionUploadCSV = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.royalBlue} !important;
  cursor: pointer;
`;

interface Props {
  uuid: string;
  organizationCodename: string;
  setRespondentsAdded: (val: boolean) => void;
}

const UploadPanelistCSV = ({
  uuid,
  organizationCodename,
  setRespondentsAdded,
}: Props) => {
  const [isSending, setIsSending] = useState(false);
  const t = useFormatMessage();

  const sendCsvFile = (event: any) => {
    const file = event.target.files[0];

    setIsSending(true);
    return api.resources
      .uploadRespondantsList({ uuid, codename: organizationCodename, file })
      .then(({ data }: any) => {
        setRespondentsAdded(data.correct_rows > 0);
        showToast({
          type: 'success',
          title: t(
            'project.collectData.manual.emails.success',
            'Succesfully uploaded emails'
          ),
        });
        setIsSending(false);
      })
      .catch(() => {
        setIsSending(false);
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
  };

  return (
    <>
      <SectionUploadCSV>
        <ButtonStyled isLoading={isSending} variant="outlined" color="primary">
          <Label htmlFor="input-file"></Label>
          {t('project.collectData.manual.uploadCSV', 'Upload CSV')}
        </ButtonStyled>
        <StyledLink onClick={generateSampleCsv}>
          {t('dashboard.respondents.sample', 'Download CSV template')}
        </StyledLink>
      </SectionUploadCSV>
      <input
        style={{ visibility: 'hidden', display: 'none' }}
        type="file"
        id="input-file"
        onChange={sendCsvFile}
        accept=".csv"
      />
    </>
  );
};

export default UploadPanelistCSV;
